import { Box, styled } from "@mui/material";

export const StyledContact = styled(Box)(({ theme }) => ({
  ".header": {
    height: "15rem",
    background: theme.color.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    h1: {
      color: theme.color.background,
    },
  },
  ".infoWrapper": {
    background: theme.color.background,
    display: "flex",
    padding: "3rem 15rem",
    justifyContent: "space-between",
    ".content": {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      h2: {
        fontWeight: "bold",
        color: theme.color.main,
        fontSize: "2.5rem",
      },
      h4: {
        width: "35rem",
        color: theme.color.dark,
        fontWeight: "bold",
      },
      strong: {
        color: theme.color.contrastColor,
      },
      ".mapWrapper": {
        paddingBlock: "2rem",
        ".map": {
          width: "40rem",
          height: "20rem",
          borderRadius: "10px",
          overflow: "hidden",
        },
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    ".header": {
      height: "25vh",
    },
    ".infoWrapper": {
      flexDirection: "column",
      padding: "1rem",
      ".content": {
        textAlign: "center",
        h4: {
          width: "100%",
        },
        ".mapWrapper": {
          ".map": {
            width: "100%",
          },
        },
      },
    },
  },
}));
